<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["BirimId", "DonemId", "Sorgulama","AltDonemId","KAltDonemId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      ilkDonemVerileri: [],
      ikinciDonemVerileri: [],
      TabloVerileri:[],
   
      donem_yili:"",
      BirimAdi:"",
      ilkyil:"",
      sonyil:"",
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId(){
      this.Get();
    }
  },

  methods: {



    Get() {
      if(this.BirimId == '90d6603e-e927-41b2-9242-78fca21bf29b'){
        this.BirimId = null;
      }
      this.bugun = new Date();

         
          this.ActionsGet({ Service: "StrPerfDonem/"+this.AltDonemId, Page: this.Page }).then((res) => {  
        
              this.ilkyil=res.Data.YilBas;

          });       
          
          this.ActionsGet({ Service: "StrPerfDonem/"+this.KAltDonemId, Page: this.Page }).then((res) => {  
      
              this.sonyil=res.Data.YilBit;

          }); 


          
          let Filter = "&Ustdonemid=" + this.DonemId + "&Gerceklesmedonemid=" + this.AltDonemId ;
          if(this.BirimId != null && this.BirimId != ""){
            Filter=Filter+"&Birimid=" + this.BirimId;
          }
        
          this.ActionsFilterGet({ Service: "StrRaporlama/GetRiskKonsolideRaporu", Page: this.Page, Filter: Filter }).then((res) => {
              
                if(res){
                    this.ilkDonemVerileri = res.Data;

                    let Filter2 = "&Ustdonemid=" + this.DonemId + "&Gerceklesmedonemid=" + this.KAltDonemId ;
                    if(this.BirimId != null && this.BirimId != ""){
                      Filter2=Filter2+"&Birimid=" + this.BirimId;
                    }

                   
                    this.ActionsFilterGet({ Service: "StrRaporlama/GetRiskKonsolideRaporu", Page: this.Page, Filter: Filter2 }).then((res2) => {
                      
                          if(res2){
                         
                              this.ikinciDonemVerileri = res2.Data;
                              console.log(this.ikinciDonemVerileri)
                              this.TabloVerileri=[];

                              for (var i=0;i<this.ilkDonemVerileri.length;i++){
                         
                              
                                  for (var s=0;s<this.ikinciDonemVerileri.length;s++){

                                        if(this.ilkDonemVerileri[i].Riskid==this.ikinciDonemVerileri[s].Riskid){
                                      
                                            this.TabloVerileri.push({"donem1":this.ilkDonemVerileri[i],"donem2":this.ikinciDonemVerileri[s]})

                                            this.ikinciDonemVerileri.splice(s,1);

                                        } 

                                  }
                      

                              }
                              this.TabloVerileri.sort(this.buyuktenKucugeSiralama)
       

                             


                          }

                    });


                }

          });


          if (this.BirimId != null && this.BirimId != ""){
            this.BirimGetir(this.BirimId);
          } else {
            this.BirimAdi="";
          }

    },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.konsolide;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 

      BirimGetir(birimid){

          this.ActionsGet({ Service: "OBirim/"+birimid, Page: this.Page }).then((res) => {  

              this.BirimAdi=res.Data.BirimAdi;

          });  

      },
      buyuktenKucugeSiralama(a, b) {
          return b.donem1.Donemriskpuanim - a.donem1.Donemriskpuanim;
      }



  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Risk Raporu',
                  'Risk Raporu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


  
    <div ref="konsolide" class="table-responsive">
      

    <div class="table-responsive">
      <table style="width:100%">
        <tr>
          <td colspan="9" style="text-align: center;">
              <div> <h4> KONSOLİDE RİSK RAPORU </h4></div>
          </td>
        </tr>
        
    
    </table>
    <br>


    <table style="border: 1px solid; border-collapse: collapse; " border="1" 
    class="table"  >

      <thead class="table-light" style="text-align: center;">
      <tr>
      <th colspan="9"><div style="text-align: left ;">İdare / Birim / Alt Birim : {{ BirimAdi }}</div><div style="text-align: right;">Tarih: {{bugun | formatDateTable}}</div></th>
       </tr>
       <tr>
        <td>1</td><td>2</td><td>3</td><td>4</td><td>5</td><td>6</td><td>7</td><td>8</td><td>9</td>
       </tr>
      <tr>
      <th rowspan="2" >Sıra No</th>
      <th rowspan="2" >Referans No</th>
      <th rowspan="2" >Stratejik Hedef</th>
      <th rowspan="2" >Birim/Alt Birim Hedefi</th>
      <th rowspan="2" >Tespit Edilen Risk</th>
      <th colspan="2" >Durum</th>
      <th rowspan="2" >Riskin Sahibi</th>
      <th rowspan="2" >Açıklama</th>
      </tr>
      <tr> 
      <th >Önceki Risk Puanı ve Rengi</th>
      <th >Mevcut Risk Puanı ve Rengi</th>

      </tr>
      </thead>
      <tbody v-for="(Risk,index) in TabloVerileri"  :key="index">
    <tr  >
    <td >{{index+1}}</td>
    <td >{{Risk.donem1.Referansno}}</td>
    <td >{{Risk.donem1.Stratejikhedef}}</td>
    <td >{{Risk.donem1.Birimhedefi}}</td>
    <td >{{Risk.donem1.Tespitedilenrisk}}</td>
    <td class="text-center" :style="{background: Risk.donem1.Renk } "><span style="color: black">{{Math.round(Risk.donem1.Donemriskpuanim)}}</span></td>
    <td class="text-center" :style="{background: Risk.donem2.Renk } "><span style="color: black">{{Math.round(Risk.donem2.Donemriskpuanim)}}</span></td>
    <td >{{Risk.donem1.Riskinsahibi}}</td>
    <td >{{Risk.donem1.Aciklama}}</td>

     </tr>
    </tbody>
    </table>
    
    </div>
    
    </div>
  </div>
</template>
